import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "unavailable-hours-settings__wrapper" }
const _hoisted_2 = { class: "unavailable-hours-settings__header" }
const _hoisted_3 = { class: "unavailable-hours-settings__add-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.isAvailabilityHoursSettingsSidebarVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAvailabilityHoursSettingsSidebarVisible) = $event)),
    title: "Unavailable hours",
    "append-to-body": "",
    size: "600",
    class: "unavailable-hours-settings",
    onClose: _ctx.closeAvailabilityHoursSettings
  }, {
    footer: _withCtx(() => [
      (_ctx.isUnavailableSettingsFormChanged)
        ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "Are you sure you want to exit without saving settings?",
            width: "250",
            "cancel-button-text": "Cancel",
            "confirm-button-text": "Yes, close",
            icon: _ctx.icons.InfoFilled,
            "confirm-button-type": "primary",
            onConfirm: _ctx.closeAvailabilityHoursSettings
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, { loading: _ctx.isAvailabilityHoursDataLoading }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Cancel ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon", "onConfirm"]))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            loading: _ctx.isAvailabilityHoursDataLoading,
            onClick: _ctx.closeAvailabilityHoursSettings
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Cancel ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["loading", "onClick"])),
      _createVNode(_component_el_popconfirm, {
        title: "Are you sure you want to save your settings?",
        width: "224",
        "cancel-button-text": "No, cancel",
        "confirm-button-text": "Yes, save",
        icon: _ctx.icons.InfoFilled,
        "confirm-button-type": "primary",
        onConfirm: _ctx.updateUnavailableHoursSettings
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            loading: _ctx.isAvailabilityHoursDataLoading,
            disabled: _ctx.isEmptyOrInvalidBlocks || !_ctx.isUpdateUnavailableHoursAvailable,
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Save ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["loading", "disabled"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["icon", "onConfirm"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref: "unavailableHoursSettingsFormRef",
          class: "unavailable-hours-settings__form",
          disabled: _ctx.isAvailabilityHoursDataLoading || !_ctx.isUpdateUnavailableHoursAvailable,
          model: _ctx.availabilityHoursFormData,
          rules: _ctx.availabilityHoursFormRules,
          "validate-on-rule-change": false,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.availabilityHoursFormData.isUnavailableHoursActive,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.availabilityHoursFormData.isUnavailableHoursActive) = $event)),
                    "active-text": _ctx.unavailableHoursActivityLabel
                  }, null, 8 /* PROPS */, ["modelValue", "active-text"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    content: _ctx.AVAILABILITY_ACTIVE_SWITCH_TOOLTIP_TEXT
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "el-icon-info" }, null, -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["content"])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityHoursFormData.unavailableHoursConfig, (unavailableHoursConfig, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "unavailable-hours-settings__item"
              }, [
                _createVNode(_component_el_form_item, {
                  class: "unavailable-hours-settings__days",
                  prop: `unavailableHoursConfig.${index}.dayList`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: unavailableHoursConfig.dayList,
                      "onUpdate:modelValue": ($event: any) => ((unavailableHoursConfig.dayList) = $event),
                      multiple: "",
                      placeholder: "Select days",
                      disabled: !_ctx.availabilityHoursFormData.isUnavailableHoursActive
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDays, ({ dayOfWeek }) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: dayOfWeek,
                            label: dayOfWeek,
                            value: dayOfWeek
                          }, null, 8 /* PROPS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["prop"]),
                _createVNode(_component_el_form_item, {
                  class: "unavailable-hours-settings__time",
                  prop: `unavailableHoursConfig.${index}.time`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_time_picker, {
                      "model-value": _ctx.getTimeRange(unavailableHoursConfig),
                      "is-range": "",
                      "range-separator": "To",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      format: "HH:mm:ss",
                      "value-format": "HH:mm:ss",
                      disabled: !_ctx.availabilityHoursFormData.isUnavailableHoursActive,
                      "onUpdate:modelValue": value => _ctx.updateTimeRange(value, index)
                    }, null, 8 /* PROPS */, ["model-value", "disabled", "onUpdate:modelValue"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["prop"]),
                _createVNode(_component_el_button, {
                  class: "unavailable-hours-settings__remove-button",
                  round: "",
                  size: "small",
                  icon: _ctx.icons.Close,
                  disabled: !_ctx.availabilityHoursFormData.isUnavailableHoursActive,
                  onClick: ($event: any) => (_ctx.removeUnavailableHoursConfigItem(index))
                }, null, 8 /* PROPS */, ["icon", "disabled", "onClick"])
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                icon: _ctx.icons.Plus,
                disabled: !_ctx.isAddUnavailableHoursButtonActive,
                onClick: _ctx.addUnavailableHoursConfigItem
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Add ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["icon", "disabled", "onClick"])
            ]),
            _createVNode(_component_el_alert, {
              class: "unavailable-hours-settings__alert",
              type: "warning",
              closable: false,
              title: _ctx.AVAILABILITY_INFO_BANNER_TEXT
            }, null, 8 /* PROPS */, ["title"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "model", "rules"])
      ])), [
        [_directive_loading, _ctx.isAvailabilityHoursDataLoading]
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onClose"]))
}